module.exports = __webpack_public_path__ + "img/椭圆563.d0466a0c.png";